

import TopItemPicker from './scheduler/TopItemPicker.vue';
import CollapseItem from './scheduler/CollapseItem.vue';
import ItemLeftHeader from './scheduler/ItemLeftHeader.vue';
import CircleProgressHeader from './scheduler/CircleProgressHeader.vue';
import { Vue, Component, Prop } from 'vue-property-decorator'
import ItemRightHeader from './scheduler/ItemRightHeader.vue';
import ManagerCollapse from './scheduler/ManagerCollapse.vue';
import ContractorCollapse from './scheduler/ContractorCollapse.vue';
import ProjectCollapse from './scheduler/ProjectCollapse.vue';

import { TimelineGroup, TimelineItem } from "vis";
import TimelineOptionsWithTemplates from "@/entities/scheduler/TimelineOptionsWithTemplates";
import { User } from "@/generated/graphql";
import Roles from "@/entities/Roles";
import RangeChangedPayload from "@/entities/scheduler/RangeChangedPayload";
import slotWrapperElement from "@/helpers/scheduler/timelineSlotHelper";
import CustomTimelineGroup from '@/entities/scheduler/CustomTimelineGroup';
import ManagerViewProjectItemFields from "@/entities/scheduler/ManagerViewProjectItem";

@Component({
    components: {
        TopItemPicker,
        ItemLeftHeader,
        CircleProgressHeader,
        ItemRightHeader,
        CollapseItem,
        ManagerCollapse,
        ContractorCollapse,
        ProjectCollapse
    },
})
export default class Scheduler extends Vue {
    //create filterBy prop
    @Prop({ default: 'Manager' }) filterBy!: string;
    @Prop({ type: Array, default: () => [] }) readonly managers!: any[];
    @Prop({ type: Array, default: () => [] }) readonly contractors!: any[];
    @Prop({ type: Array, default: () => [] }) readonly projects!: any[];

    @Prop({ type: Object, required: true }) readonly currentUser!: User;
    @Prop({ type: String, default: null }) readonly companyId!: string;
    // @Prop({ type: Array, required: true }) readonly groups!: CustomTimelineGroup[];
    // @Prop({ type: Array, required: true }) readonly items!: ManagerViewProjectItemFields[];
    @Prop({ type: Array, default: () => [] }) readonly itemsSelection!: any[];
    @Prop({ type: Object, default: () => ({}) }) readonly customOptions!: TimelineOptionsWithTemplates;
    @Prop({ type: String, default: "" }) readonly schedulerView!: string;

    selectedOption: string = "Days";

    //current date
    currentDate = new Date();
    isCollapsed: boolean = false;

    //current month name
    currentMonth: string = this.getMonthName(this.currentDate.getMonth());

    //current week start month 



    //current week end month year is prev



    monthNumber = this.currentDate.getMonth()


    //getmonth name
    getMonthName(month: number): string {
        let monthName: string = '';
        switch (month) {
            case 0:
                monthName = 'January';
                break;
            case 1:
                monthName = 'February';
                break;
            case 2:
                monthName = 'March';
                break;
            case 3:
                monthName = 'April';
                break;
            case 4:
                monthName = 'May';
                break;
            case 5:
                monthName = 'June';
                break;
            case 6:
                monthName = 'July';
                break;
            case 7:
                monthName = 'August';
                break;
            case 8:
                monthName = 'September';
                break;
            case 9:
                monthName = 'October';
                break;
            case 10:
                monthName = 'November';
                break;
            case 11:
                monthName = 'December';
                break;
        }
        return monthName;
    }

    //current year
    currentYear: number = this.currentDate.getFullYear();

    //current day
    currentDay: number = this.currentDate.getDate();

    //current day of the week
    currentDayOfWeek = this.currentDate.getDay();

    // getLength() {
    //     console.log('length of mainSchContainer' + parseFloat(window.getComputedStyle(document.getElementById('mainSchContainer')).width))


    // }

    //current week number
    currentWeekNumber: number = this.getWeekNumber(this.currentDate);

    //create function to get week number
    getWeekNumber(d: Date) {
        // Copy date so don't modify original
        d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
        // Set to nearest Thursday: current date + 4 - current day number
        // Make Sunday's day number 7
        d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
        // Get first day of year
        var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
        // Calculate full weeks to nearest Thursday
        var weekNo = Math.ceil((((d.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
        // Return array of year and week number

        return weekNo;
    }

    get getWeekStartDay() {
        // alert(new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate() - this.currentDate.getDay() + 1).getMonth())
        return new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate() - this.currentDate.getDay()).getDate();
    }
    get getWeekEndDay() {
        // alert(new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate() + (7 - this.currentDate.getDay())).getMonth())
        return new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate() + (6 - this.currentDate.getDay())).getDate();
    }
    get getMonthOfWeekStartDay() {
        let month = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate() - this.currentDate.getDay()).getMonth();
        return this.getMonthName(month);
    }
    get getMonthOWeekEndDay() {
        let month = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate() + (6 - this.currentDate.getDay())).getMonth();
        return this.getMonthName(month);
    }

    //get isdays 
    get isDays() {
        return this.selectedOption == "Days";
    }

    get isWeeks() {
        return this.selectedOption == "Weeks";
    }

    get isMonths() {
        return this.selectedOption == "Months";
    }

    //get quater of the year
    get getQuarter() {
        return Math.floor((this.monthNumber) / 3) + 1;
    }

    get columnSpan() {
        let screen_width = screen.availWidth;
        if (this.isDays) {
            return (screen_width * (10 / 100)) + "px";
        }
        else if (this.isWeeks) {
            return (screen_width * (30 / 100)) + "px";
        }
        else if (this.isMonths) {
            return (screen_width * (40 / 100)) + "px";
        }
    }
    get columnLength() {
        if (this.isDays) {
            return 7;
        }
        else if (this.isWeeks) {
            return 4;
        }
        else if (this.isMonths) {
            return 3;
        }
    }

    //switch to next month
    nextQuarter() {
        this.currentDate = new Date(this.currentYear, this.monthNumber + 3, 1);
        this.monthNumber += 3;
        if (this.monthNumber > 11) {
            this.monthNumber = 0;
            this.currentYear++;
        }
        this.currentMonth = this.getMonthName(this.monthNumber);
        var e: RangeChangedPayload = {
            byUser: true,
            start: this.getWeekStartDate,
            end: this.getWeekEndDate,
            event: {
                additionalEvent: undefined
            }
        }
        this.$emit("rangechanged", e);
    }

    rangeChanged(e: RangeChangedPayload): void {
        this.$emit("rangechanged", e);
    }


    //switch to previous quarter
    previousQuarter() {
        this.currentDate = new Date(this.currentYear, this.monthNumber - 3, 1);
        this.monthNumber -= 3;
        if (this.monthNumber < 0) {
            this.monthNumber = 9;
            this.currentYear--;
        }
        this.currentMonth = this.getMonthName(this.monthNumber);
    }


    //switch to next week
    nextWeek() {
        //reset current date to next week
        this.currentDate = new Date(this.currentDate.setDate(this.currentDate.getDate() + 7));
        this.currentWeekNumber = this.getWeekNumber(this.currentDate);
        this.currentDayOfWeek = this.currentDate.getDay();
        this.currentDay = this.currentDate.getDate();
        var e: RangeChangedPayload = {
            byUser: true,
            start: this.getWeekStartDate,
            end: this.getWeekEndDate,
            event: {
                additionalEvent: undefined
            }
        }
        this.$emit("rangechanged", e);
    }

    get getWeekStartDate() {
        return new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate() - this.currentDate.getDay() + 1)
    }
    get getWeekEndDate() {
        return new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate() + (7 - this.currentDate.getDay()));
    }

    //switch to previous week
    previousWeek() {
        this.currentDate = new Date(this.currentDate.setDate(this.currentDate.getDate() - 7));
        this.currentWeekNumber = this.getWeekNumber(this.currentDate);
        this.currentDayOfWeek = this.currentDate.getDay();
        this.currentDay = this.currentDate.getDate();
        var e: RangeChangedPayload = {
            byUser: true,
            start: this.getWeekStartDate,
            end: this.getWeekEndDate,
            event: {
                additionalEvent: undefined
            }
        }
        this.$emit("rangechanged", e);
    }
    today() {
        this.currentDate = new Date();
        this.currentWeekNumber = this.getWeekNumber(this.currentDate);
        this.currentDayOfWeek = this.currentDate.getDay();
        this.currentDay = this.currentDate.getDate();
        this.currentMonth = this.getMonthName(this.currentDate.getMonth());
        this.currentYear = this.currentDate.getFullYear();
        var e: RangeChangedPayload = {
            byUser: true,
            start: this.getWeekStartDate,
            end: this.getWeekEndDate,
            event: {
                additionalEvent: undefined
            }
        }
        this.$emit("rangechanged", e);
    }

    next() {
        switch (this.selectedOption) {
            case 'Days':
                this.nextWeek();
                break;
            case 'Weeks':
                this.nextWeek();
                break;
            case 'Months':
                this.nextQuarter();
                break;
        }

    }
    prev() {
        switch (this.selectedOption) {
            case 'Days':
                this.previousWeek();
                break;
            case 'Weeks':
                this.previousWeek();
                break;
            case 'Months':
                this.previousQuarter();
                break;
        }
    }
    optionChange(value: string) {
        this.selectedOption = value;
        // this.getLength()
    }

    //get current week dates
    get getWeekDates() {
        var weekDates: any = [];
        var currentDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate() - this.currentDate.getDay());
        for (var i = 0; i < 7; i++) {
            weekDates.push(new Date(currentDate).getDate());
            currentDate.setDate(currentDate.getDate() + 1);
        }
        return weekDates;
    }


    //get current Quarter months
    get getQuarterMonths() {
        var quarterMonths: any = [];
        var currentDate = new Date(this.currentDate.getFullYear(), this.monthNumber, 1);
        for (var i = 0; i < 3; i++) {
            quarterMonths.push(this.getMonthName(currentDate.getMonth()));
            currentDate.setMonth(currentDate.getMonth() + 1);
        }
        return quarterMonths;
    }

    //get current week and next 3 week dates
    get getWeeks() {
        var weeks: any = [];
        var currentDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate() - this.currentDate.getDay());
        for (var i = 0; i < 4; i++) {
            weeks.push(this.getWeekNumber(currentDate));
            currentDate.setDate(currentDate.getDate() + 7);
        }
        return weeks;
    }


    //check if day is current day
    isCurrentDay(day: number) {
        return day == this.currentDay;
    }

    //check if week is current week
    isCurrentWeek(week: number) {
        return week == this.currentWeekNumber;
    }

    //check if month is current month
    isCurrentMonth(month: string) {
        return month == this.currentMonth;
    }
    //switch to today

    //get earliest date on the picker
    get getEarliestDate() {
        var earliestDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate() - this.currentDate.getDay());
        return earliestDate;
    }

    collapseAll() {
        this.isCollapsed = !this.isCollapsed;
    }

}
